import {DG_axiosNormal} from "../../../../custom/axios/normal";

const urlNotification = '/dogoo/notification-push-rest/v2.0/push-notifications'
const urlUserInformation = '/dogoo/user-info-rest/v2.0/user-information'

export async function postNotificationPush(notificationPush) {
    const response = await DG_axiosNormal.post(urlNotification, notificationPush);
    return response?.data || []
}

export async function getNotificationPushByEmployeeId(id) {
    const response = await DG_axiosNormal.get(urlNotification + `/by-account/${id}`)
    return response?.data || []
}

export async function getUserInformationByTypeAndId(id, type) {
    const response = await DG_axiosNormal.get(urlUserInformation + `/by-type/${type}/by-id/${id}`)
    return response?.data || []
}

export async function deleteNotificationPushByDeviceTokenAndAccountId(deviceToken, accountId) {
    try{
        const response = await DG_axiosNormal.delete(urlNotification + `/by-device-token/${deviceToken}/by-account/${accountId}`)
        return response?.data || []
    }catch (e) {
        return [];
    }
   
}

export async function postObjectInformation(userInformations) {
    const response = await DG_axiosNormal.post(urlUserInformation, {userInformations: userInformations});
    return response?.data || []
}

export async function getAllUserInformation() {
    const response = await DG_axiosNormal.get(urlUserInformation + `/all-user-information`)
    return response?.data || []
}